export enum FeatureFlags {
  Apid = 'apid', // Additional Product ID , ANZ specific feature
  AutoRedemption = 'autoRedemption',
  ShoppingCart = 'shoppingCart',
  Merchandise = 'merchandise',
  TcListing = 'tcListing',
  PoolPoints = 'poolPoints',
  MultiPointsBalance = 'multiPointsBalance',
  CashbackToBankAccount = 'cashbackToBankAccount',
}
